import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './logpdf.js';
import __var_2__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Weibull distribution logarithm of probability density function (PDF).
*
* @module @stdlib/stats/base/dists/weibull/logpdf
*
* @example
* var logpdf = require( '@stdlib/stats/base/dists/weibull/logpdf' );
*
* var y = logpdf( 2.0, 1.0, 0.5 );
* // returns ~-3.297
*
* var mylogpdf = logpdf.factory( 7.0, 6.0 );
* y = mylogpdf( 7.0 );
* // returns ~-1.864
*/

// MODULES //
var setReadOnly = __var_0__;
var logpdf = __var_1__;
var factory = __var_2__;


// MAIN //

setReadOnly( logpdf, 'factory', factory );


// EXPORTS //
export default logpdf;
